import React, { useState } from "react";
import SbEditable from "storyblok-react";
import Testimonial from "./Testimonial";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BackgroundColour } from 'src/utils/ColourUtilities'

const TestimonialsSimpleCentered = ({ blok }) => {
  const bgChange =
    blok.content_type === "magazine" ? blok.secondary_colour : "";

  const [currentIndex, setCurrentIndex] = useState(0);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    fade: true,
    beforeChange: (current, next) => setCurrentIndex(next),
    appendDots: (dots) => {
      return (
        <div>
          <ul className="!mb-[-25px]">
            {dots.map((item, index) => {
              return (
                <li className="!m-[5px] sm:!m-[5px] !h-[6px] sm:!h-[10px] !w-[6px] sm:!w-[10px]" key={index}>
                  {item.props.children}
                </li>
              );
            })}
          </ul>
        </div>
      );
    },
    customPaging: (i) => (
        <div
            className={`relative w-full h-full transition-colors duration-500 border border-white ${
            i === currentIndex ? "bg-red" : "bg-white"
            }`}
        ></div>
    ),
  };

  return (
    <SbEditable content={blok} key={blok._uid}>
      <section
        className={`pt-12 pb-20 overflow-hidden md:py-20 lg:py-24 ${blok.content_type === "magazine" ? '' : BackgroundColour(blok.colour)}`}
        style={{ background: bgChange }}
      >
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative">
            <blockquote className="">
              <Slider {...settings}>
                {blok.items.map((item) => {
                  return (
                    <Testimonial
                      blok={{
                        ...item,
                        text_colour: blok.text_colour,
                        content_type: blok.content_type,
                        blok_colour: blok.colour
                      }}
                      key={item._uid}
                    />
                  );
                })}
              </Slider>
            </blockquote>
          </div>
        </div>
      </section>
    </SbEditable>
  );
};

export default TestimonialsSimpleCentered;
